import { Route, Navigate } from "react-router-dom";
import Login from "../Pages/Login";
import LovedOneList from "../Pages/LovedOneList";
let unathorizedRoutes = [
  {
    component: Login,
    path: "/",
  },
];

const Unauthorized = ({ children }) => {
  return localStorage.getItem("admin_token") ? (
    <Navigate to="/lovedone/list" />
  ) : (
    children
  );
};

export default function UnathorizedRoutes() {
  return unathorizedRoutes.map((route, index) => {
    let AuthComponent = route.component;
    return (
      <Route
        path={`${route.path}`}
        element={
          <Unauthorized>
            {" "}
            <AuthComponent />{" "}
          </Unauthorized>
        }
        key={index}
      />
    );
  });
}
